import React,{useEffect, useState} from 'react';
import Backdrop from '@material-ui/core/Backdrop';
import { makeStyles } from '@material-ui/core/styles';
// import styles from "../../../LeftNavigation/DesignerControls/BasicControls.module.css"
import style from "../../LeftNavigation/DesignerControls/BasicControls.module.css";
import ELEMENT from '../../../UI/BasicFormControls/ELEMENT';
import GreyCross from "../../../Icons/GreyCross.svg";
import { functions } from '../ApplicationAPI/applicationApi';


const useStyles = makeStyles((theme) => ({
 backdrop: {
 zIndex: 200,
 color: '#fff',
 },
}));
 
function CanvasSubform(props) {

   // console.log("Canvas Subform ", props);
  
    const classes = useStyles();  

    function handleClose(){
      if(window.subformDoneClick){
        // console.log("close..", props);
        window.subformDoneClick();
        functions.updateJSON();
      }
    }

    function handleEscapeKey(e){
      if(e.code === "Escape"){
        props.closeSubformOnPreview();
        handleClose();
      } 
     }
     useEffect(()=>{
      document.getElementById("backdropDiv")?.focus();
      
     },[])
    return (
    <>
    <Backdrop id="backdrop" className={classes.backdrop} open={true} >
   
    <div tabIndex="0" onKeyDown={(e) => handleEscapeKey(e)} id="backdropDiv" className={style.backdropDivSubform}>
      {/* <div> */}
 

          <div  className={style.headingSubform}> 
      {/* <p style={{color:"black"}}  >{props.subFormData.pageStyle["SubformTitle"]}</p> */}
       <span className={style.headingSubformTitle} style={{color:"black"}}  >{props.subFormData?.pageStyle?.["SubformTitle"]}</span> 
       <span>
          <img 
                   onClick={()=>{props.closeSubformOnPreview(); handleClose();}}
                  className={style.defaultImageCrossSubform}
                   alt="Close Icon" 
                   src={GreyCross}
                   /></span>
          </div> 
      <div className={style.subFormBody}>
        <ELEMENT
        containerId={props.containerId}
          {...props} 
          data={props.subFormData}
        />
      </div>
   
    </div>
    
    </Backdrop>
    </>
    );
}
export default CanvasSubform;